import React from 'react';
import { concatStrings } from '../utilities';
import DfbIcon from './dfb_icon';

const DfbIconButton = ({ tagName, link, target, type, filled, big, title, image, icon_type, label, add_class, ...otherProps }) => {
  const TagName = `${tagName.toLowerCase()}`
  const anchorLink = (TagName === 'a' ? { href: link } : {})
  const anchorTarget = (TagName === 'a' ? { target: target } : {})
  const buttonType = (TagName === 'button' ? { type: type } : {})
  const filledClass = (filled ? 'dfb-IconButton--filled' : '')
  const bigClass = (big ? 'dfb-IconButton--big' : '')
  const anchorTitle = (title && title.length > 0 ? { title: title } : {})
  return (
    <TagName {...anchorLink} {...anchorTitle} {...buttonType} {...anchorTarget} className={concatStrings('dfb-IconButton', filledClass, bigClass, add_class)}>
      { !image &&
        <DfbIcon
          icon_type={icon_type}
          add_class="dfb-IconButton-icon"
          {...otherProps}
        />
      }
      { image && image.length > 0 &&
        <img className="dfb-IconButton-image" src="/assets/images/dfb-icon-akademie-arrow-right.svg" alt="Lorem ipsum"></img>
      }
      <span className="dfb-IconButton-label">{label}</span>
    </TagName>
  )
}

DfbIconButton.defaultProps = {
  tagName: 'button',
  type: 'button',
  label: 'IconButton',
  filled: false,
  big: false,
}

export default DfbIconButton;
